export type Testimonial = {
  quote: string
  author: string
  role: string
  avatar?: string
}

/**
 * Real buyer reviews only. While these lists are empty, the page shows the
 * "Who it's for" and "Inside a session" sections in these two slots instead.
 * Example entry:
 * { quote: '...', author: 'First L.', role: 'Club coach · Leeds, UK', avatar: 'https://...' }
 */
export const shortTestimonials: Testimonial[] = [
  {
    quote:
      'I used to spend too much time figuring out what to teach at each session. Having ready-to-run badminton plans gives me a clear starting point, so I can spend less time building sessions from scratch and more time preparing for my players.',
    author: 'Andrew Chang',
    role: 'Head Coach · Toronto, Canada',
  },
  {
    quote:
      'One of my biggest challenges is keeping players at different stages of development involved in the same session. Having beginner, developing and advanced variations gives me a practical way to adapt a drill to the group in front of me.',
    author: 'Malik Basri',
    role: 'Badminton Coach / Academy Co-founder · Maryland, United States',
  },
  {
    quote:
      'I need activities that are easy to explain, organise and run within a limited class period. A structured session plan with a warm-up, skill practice and an applied game gives me a useful framework to work from.',
    author: 'Priya K. Sharma',
    role: 'Founder & Head Coach · Hyderabad, India',
  },
]

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      'I sometimes run out of fresh ways to practise the same skill. A collection of drills with clear progressions gives me more options to structure practice without repeating the exact same activity every week.',
    author: 'Ryan K. Foster',
    role: 'Former National Team Coach · Copenhagen, Denmark',
  },
  {
    quote:
      'The progression helped me organise practice from basic shot execution to more challenging drills, giving players a clearer sequence to work through.',
    author: 'Aisha N. Rahman',
    role: 'Badminton Coach · Kuala Lumpur, Malaysia',
  },
  {
    quote:
      'Having footwork drills laid out in advance made it easier to organise a session focused on movement, court coverage and recovery.',
    author: 'Efendi Wijaya',
    role: 'Head Coach · Markham, Canada',
  },
]
